module.exports = __webpack_public_path__ + "img/johan_cv_4.66ab3c77.jpg";